import https from '@/utils/https';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
const router = useRouter();

export const commonRequest = (url: string, method, params?: any, requestFormat?: any, isError?: boolean) => {
    return https()
        .request(url, method, params, requestFormat)
        .then((res: any) => {
            if (res?.code === 20001 || res?.code === 20002) {
                router.push('/login');
            }
            return res;
        })
        .catch((err: any) => {
            if (err.response.data.code === 401) {
                isError ? ElMessage.error(`Request Error ${String(err.response.data.code)}`) : null;
            }
            if (err.response.data.code === 20002 || err.response.data.code === 20001) {
                router.push('/login');
            }

            return err.response.data;
        });
};
